import React, { useEffect, useState } from "react";
import "./Indivisiual.css";import api from "../../utils/ApiMethod";
import { motion } from "framer-motion";
import Breadcrumb from "../../components/common/Breadcrumb";

import { Box, Flex, Text, Image } from "@chakra-ui/react";
import { Helmet } from "react-helmet-async";

const MotionBox = motion(Box);

// Scale the message to its length so short messages don't look lost beside the photo
const getMessageStyle = (textLength) => {
  const isShort = textLength < 350;
  const fontSize = isShort
    ? { base: "xl", md: "2xl", lg: "3xl" }
    : textLength < 700
    ? { base: "lg", md: "xl" }
    : { base: "md", md: "lg", lg: "xl" };
  return { fontSize, lineHeight: isShort ? "taller" : "tall" };
};

const SecretarySportsDepartment = () => {
  const [harjotPageData, setHarjotPageData] = useState([]);

  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const handleFetchData = async () => {
    try {
      const data = await api.fetchData("/api/acsdepartmentmessage");
      setHarjotPageData(data);
      // console.log("Fetched data:", data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Secretary, Sports Department - BSSA</title>
        <meta
          name="description"
          content="Learn about the Secretary's role in advancing sports initiatives and infrastructure development in Bihar."
        />
      </Helmet>

      {harjotPageData &&
        harjotPageData.map((elem, index) => {
          const paragraph = elem?.paragraph ?? "";
          const textLength = paragraph.length;
          const messageStyle = getMessageStyle(textLength);

          return (
            <React.Fragment key={elem?._id ?? index}>
              <Breadcrumb
                pageName=" Bihar Chief minister message"
                pageTitle="Chief minister message"
                id="#chief-minister"
                img_url={`https://api.biharsports.org/${elem?.bannerUrl?.replace(
                  "public/images/",
                  "images/"
                )}`}
                mobile_banner={`https://api.biharsports.org/${elem?.mobileBannerUrl?.replace(
                  "public/images/",
                  "images/"
                )}`}
              />
              <Flex
                direction={{ base: "column", md: "row" }}
                align={{ base: "center", md: "stretch" }}
                gap={{ base: 6, md: 10 }}
                mt="10"
                mb="10"
                px={[5, 10, 20]}
              >
                <MotionBox
                  flexShrink={0}
                  w={{ base: "100%", md: "40%", lg: "35%" }}
                  maxW="480px"
                  display="flex"
                  justifyContent="center"
                  alignSelf={{ base: "center", md: "flex-start" }}
                  position={{ md: "sticky" }}
                  top={{ md: "100px" }}
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, delay: 1 }}
                >
                  <Image
                    borderRadius="lg"
                    boxShadow="md"
                    // src={`https://api.biharsports.org/${elem?.pageImage?.replace(
                    //   "public/images/",
                    //   "images/"
                    // )}`}
                    // src="https://biharsports.org/img/prioritysports/mahendra-kumar-ias.jpeg"
                    // src="https://biharsports.org/img/vinod-gunjyal.jpeg"
                    src="https://biharsports.org/img/deepak-anand.jpeg"
                    alt="Secretary"
                    w="auto"
                    h="auto"
                    maxW="100%"
                    maxH={{ base: "420px", md: "520px" }}
                    objectFit="contain"
                  />
                </MotionBox>

                <Flex
                  flex="1"
                  minW={0}
                  w="100%"
                  direction="column"
                  justify={{ base: "flex-start", md: "center" }}
                  alignSelf="stretch"
                >
                  {/* Name + designation (same conventions as Ravindran.jsx) */}
                  <Text
                    fontWeight="bold"
                    textTransform="uppercase"
                    fontSize={["18", "42"]}
                    letterSpacing="wide"
                    color="teal.800"
                  >
                    {elem?.heading}
                  </Text>
                  <Text
                    fontWeight="bold"
                    textTransform="uppercase"
                    align={"right"}
                    fontSize={["10", "13"]}
                    letterSpacing="wide"
                    color="black"
                  >
                    {elem?.designation}
                  </Text>

                  {/* Message */}
                  <Box mt={2} py="2">
                    <Text
                      align={"left"}
                      color="gray.500"
                      fontSize={messageStyle.fontSize}
                      lineHeight={messageStyle.lineHeight}
                      letterSpacing="wide"
                      fontWeight="bold"
                    >
                      {expanded || textLength <= 850
                        ? paragraph
                        : `${paragraph.slice(0, 850)}...`}
                    </Text>
                    {textLength > 850 && (
                      <button
                        onClick={toggleExpand}
                        style={{ color: "blue", fontWeight: "500" }}
                      >
                        {expanded ? "Read less" : "Read more"}
                      </button>
                    )}
                  </Box>
                </Flex>
              </Flex>
            </React.Fragment>
          );
        })}
    </div>
  );
};
export default SecretarySportsDepartment;
